export default __webpack_public_path__ + "static/media/graphql.9e11f395.svg";